import { render, staticRenderFns } from "./Taxonomias.vue?vue&type=template&id=5c4333a4&scoped=true&"
import script from "./Taxonomias.vue?vue&type=script&lang=js&"
export * from "./Taxonomias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4333a4",
  null
  
)

export default component.exports